"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignInDropdown = void 0;
const react_1 = __importDefault(require("react"));
const SimpleDesktopDropdownMenu_1 = require("../menu/SimpleDesktopDropdownMenu");
const SignInLink_1 = require("./SignInLink");
const SignInDropdown = ({ signInLinks = [], rightAlign }) => {
    return (react_1.default.createElement(SimpleDesktopDropdownMenu_1.SimpleDesktopDropdownMenu, { summaryNode: react_1.default.createElement(SignInLink_1.SignInLink, { nofocus: true }), links: signInLinks, dropdownAlignCenter: true, textAlignCenter: true, rightAlign: rightAlign, menuId: "signin" }));
};
exports.SignInDropdown = SignInDropdown;
//# sourceMappingURL=SignInDropdown.js.map